<template>
    <section id="wrapper" class="auth-saas auth-linear">
        <div class="auth-saas__layout auth-saas__layout--centered">
            <div class="auth-saas__form-column">
                <div class="auth-saas__form-inner">
                    <div class="auth-saas__card auth-linear__card">
                        <div class="auth-saas__badge">{{trans('auth.tnc')}}</div>
                        <h1 class="auth-saas__title">{{trans('auth.tnc')}}</h1>
                        <p class="auth-saas__subtitle">Review the admin usage terms before returning to the console.</p>
                        <div class="auth-linear__notice">
                            <strong>{{trans('auth.tnc')}}</strong>
                            <span>Here goes terms and conditions!</span>
                        </div>
                        <router-link class="auth-saas__btn-secondary d-block text-center" to="/">{{trans('general.back')}}</router-link>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        mounted(){

            if(!helper.featureAvailable('terms_and_conditions')){
                helper.featureNotAvailableMsg();
                this.$router.push('/home');
            }
        }
    }
</script>

<style scoped>
.auth-linear__card {
    box-shadow: 0 24px 70px rgba(31, 35, 48, 0.075), inset 0 1px 0 rgba(255, 255, 255, 0.86);
}

.auth-linear__notice {
    display: grid;
    gap: 0.35rem;
    margin: 1rem 0;
    padding: 1rem;
    border: 1px solid #e5e8ef;
    border-radius: 16px;
    color: #252936;
    background: linear-gradient(180deg, #fbfcff, #f7f8fb);
}

.auth-linear__notice span {
    color: #687083;
    line-height: 1.6;
}
</style>
